import { GetStaticProps } from 'next';
import { createGlobalStyle } from 'styled-components';

import { MarketingLayout, MarketingLayoutProps } from '~/layouts/MarketingLayout';
import { getPageBySlug } from '~/lib/contentful/api/page';
import { PageData } from '~/lib/contentful/custom-types';
import { AdobeSplashHeroTemplate } from '~/old-marketing/components/heros/templates/AdobeSplashHeroTemplate';
import { sectionRenderer } from '~/old-marketing/utils/sectionRenderer';

const GlobalStyles = createGlobalStyle({
  body: {
    backgroundColor: 'black',
    overflowX: 'hidden',
  },
});

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const { layoutSettings, seo, ...adobePremiereProPage } = await getPageBySlug(!!preview, '/adobe-premiere-pro');

  return {
    props: {
      adobePremiereProPage,
      layout: {
        ...layoutSettings,
        id: adobePremiereProPage?.id ?? null,
        preview: !!preview,
        seo,
      },
    },
  };
};

export default function AdobePremiereProPage({
  adobePremiereProPage,
}: { adobePremiereProPage: PageData } & MarketingLayoutProps) {
  return (
    <>
      <GlobalStyles />
      <AdobeSplashHeroTemplate content="Air for Adobe Premiere Pro" title="Remote video collaboration, solved." />

      {adobePremiereProPage?.sections?.map((section, index) => sectionRenderer(section, index, false))}
    </>
  );
}

AdobePremiereProPage.layout = MarketingLayout;
